import {
  http,
  delayIt,
} from '../utils/http';

export function getList(params) {
  return http.get('/api/oa/approval', {
    params
  })
}

export function modifyPaymentInfo(params) {
  return http.post('/api/oa/fix-payment-information',
    params
  )
}